var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"chapter-button",attrs:{"id":`chapter-button--${_vm.type}`},on:{"click":_vm.clickHandler}},[_c('Icon',{attrs:{"type":_vm.type,"color":_vm.color}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }